import { CREATE_REQUEST_ROUTE } from './routeRegistry'
import { useIsAllowed } from './useIsAllowed'

/**
 * Whether to offer starting a request. Anything but a firm yes hides the entry point: a request
 * started on a withheld answer would be refused at the endpoint.
 */
export const useCanCreateRequest = (): boolean => useIsAllowed(CREATE_REQUEST_ROUTE)
